import React, { FC } from 'react';
import AdminRolesListPage from './adminrole-list';
import { Route, Routes } from 'react-router-dom';
import RoleInformationPage from 'src/common/components/business/role-information-page';
import { useTranslation } from 'react-i18next';
import { Selector } from 'src/common/types';

const AdminRolesIndex: FC = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route path={`/*`} element={<AdminRolesListPage />} />
      <Route
        path={`/new`}
        element={
          <RoleInformationPage
            header={t('NewRole')}
            maxSelector={Selector.Admin}
            mode="new"
            previousRoute="/adminroles"
            routes={[
              { path: '', breadcrumbName: t('Home') },
              { path: 'adminroles', breadcrumbName: t('AdminRoles') },
              { path: 'new', breadcrumbName: t('NewAdminRole') },
            ]}
          />
        }
      />
      <Route
        path={`/update/:id`}
        element={
          <RoleInformationPage
            header={t('EditRole')}
            maxSelector={Selector.Admin}
            mode="edit"
            previousRoute="/adminroles"
            routes={[
              { path: '', breadcrumbName: t('Home') },
              { path: 'adminroles', breadcrumbName: t('AdminRoles') },
              { path: `update`, breadcrumbName: t('EditAdminRole') },
            ]}
          />
        }
      />
    </Routes>
  );
};

export default AdminRolesIndex;
